<div class="users-container view">
  <div class="title">{{ 'users.title' | transloco }}</div>
  <app-chart [config]="chartConfig" [hideButton]="true" [hideGrandTotal]="true"></app-chart>

  <div class="users-legend">
    <div class="users-legend__item">
      <span class="users-legend__item__label">{{ 'stats.users.legend.sin_cuenta.label' | transloco }}</span>
      <span class="users-legend__item__desc">{{ 'stats.users.legend.sin_cuenta.tooltip' | transloco }}</span>
    </div>
    <div class="users-legend__item">
      <span class="users-legend__item__label">{{ 'stats.users.legend.con_cuenta.label' | transloco }}</span>
      <span class="users-legend__item__desc">{{ 'stats.users.legend.con_cuenta.tooltip' | transloco }}</span>
    </div>
  </div>
</div>